import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

export const TopRelativeVolume = ({ note, realatedVol, tableTime, vol }) => {
  // const [category, setCategory] = useState(null);
  const [volume, setVolume] = useState([]);
  const [call, setCall] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const series = [
    { name: "Put", data: volume },
    {
      name: "Call",
      data: call,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 640,
      stacked: true,
    },
    colors: ["#008FFB", "#FF4560"],
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "80%",
        borderRadius: 7,
        radiusOnLastStackedBar: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },

    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    yaxis: {
      min: -50000000,
      max: 50000000,
      title: {
        // text: 'Age',
      },
    },
    tooltip: {
      shared: false,
      x: {
        formatter: function (val) {
          return val;
        },
      },
      y: {
        formatter: function (val) {
          return Math.abs(val);
        },
      },
    },

    xaxis: {
      categories,
      title: {
        text: "Premium",
      },
      labels: {
        formatter: function (val) {
          return Math.abs(Math.round(val));
        },
      },
    },
  };

  useEffect(() => {
    const Put = vol.daily.map((v) => parseInt(v.put));
    const Call = vol.daily.map((calls) => parseInt(-calls.call));
    const categories = vol.daily.map((V) => V.ticker);
    setVolume(Put);
    setCall(Call);
    setCategories(categories);
    setLoading(false);
  }, [vol]);
  console.log(vol, series);

  if (isLoading) {
    return <h1>loading...</h1>;
  }

  return (
    <section className="mt-4">
      {/* TODO: hide top 4 relative vol tickers */}
      {/* <div>
        <span className="font-weight-bold">{note.t}</span>
        <div className="text-black-50 my-3">
          Top Relative Volume (AVG VOL&#10095;500K)
        </div>
        <div className="row row-cols-2 mx-0">
          <div className="col">
            <div className="d-flex mb-2 font-weight-bold">
              <span className="text-capitalize">1.) ETSY</span>
              <span className="ml-auto">{realatedVol.t.ETSY}</span>
            </div>
          </div>
          <div className="col">
            <div className="d-flex mb-2 font-weight-bold">
              <span className="text-capitalize">2.) AAL</span>
              <span className="ml-auto">{realatedVol.t.AAL}</span>
            </div>
          </div>
          <div className="col">
            <div className="d-flex mb-2 font-weight-bold">
              <span className="text-capitalize">3.) Shop</span>
              <span className="ml-auto">{realatedVol.t.SHOP}</span>
            </div>
          </div>
          <div className="col">
            <div className="d-flex mb-2 font-weight-bold">
              <span className="text-capitalize">4.) Goog</span>
              <span className="ml-auto">{realatedVol.t.GOOG}</span>
            </div>
          </div>
        </div>
      </div> */}

      <div className="shadow border p-4 mt-2 mb-5 border border-dark rounded-xl bg-white">
        <div className="text-center mb-3">
          <span className="font-weight-bold text-capitalize h5">
            Daily Top 10
          </span>
          <div className="text-black-50 my-2 h6">{tableTime.t}</div>
        </div>
        {/* <div className="row row-cols-2">
          <div className="col">
            <div className="d-flex align-items-center justify-content-center">
              <span
                className="badge badge-info d-flex p-2 rounded-circle mr-1"
                style={{ padding: "0.35rem" }}
              ></span>
              <span>Received</span>
            </div>
          </div>
          <div className="col">
            <div className="d-flex align-items-center justify-content-center">
              <span
                className="badge badge-danger d-flex p-2 rounded-circle mr-1"
                style={{ padding: "0.35rem" }}
              ></span>
              <span>Transfered</span>
            </div>
          </div>
        </div> */}

        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={400}
        />
      </div>
    </section>
  );
};
